var exports = {
  "B": "x234b8571--02eeb6--tabs-wrapper",
};

module.exports = exports;
